/** Patients per page in the Patient List roster. */
export const ROSTER_PAGE_SIZE = 25;

/** Idle time after the last keystroke before the roster search fires. */
export const ROSTER_SEARCH_DEBOUNCE_MS = 500;

/**
 * Rows per page in the Patient Overview sections (Past Appointments, Visit
 * Purposes). Both endpoints return a Patient's full history in one response, so
 * this paging is client-side only — it keeps a long history from pushing the
 * rest of the overview off the screen.
 */
export const SECTION_PAGE_SIZE = 5;

/** Shared palette, matching the surrounding application chrome. */
export const PR_COLORS = {
  primary: "#0E3F66",
  heading: "#125386",
  headingStrong: "#0b2b45",
  subtle: "#496a80",
  menuIdle: "#E9FAF9",
  border: "#C7C7CC",
  tableHead: "#f5f7fa",
  muted: "#666",
  quiet: "#888",
  faint: "#aaa",
  placeholder: "#ccc",
  chevron: "#b6c2cc",
};
